import React from 'react';
import { MainView, UsersMain, UsersSub, FIUsersSub} from '../components/components.js';

class Users extends React.Component {


	constructor(props) {
		super(props);

		this.whereOnClick = this.whereOnClick.bind(this);
		this.fiOnClick = this.fiOnClick.bind(this);
		this.getFIUserData = this.getFIUserData.bind(this);

		this.state = {
			page : "main", 
			fi : {
				data : {},
				dataError : false
			}
		};
	}

	componentDidMount() {

		if(this.state.fi.data !== null && Object.keys(this.state.fi.data).length === 0 && this.state.fi.dataError === false) {
			this.getFIUserData();
		}

		
	}


	whereOnClick(e) {
		const newPage = (this.state.page === "main") ? "whereSub" : "main";
		this.setState({page : newPage});

	}

	fiOnClick(e) {
		const newPage = (this.state.page === "main") ? "fiSub" : "main";
		this.setState({page : newPage});
	}



	getFIUserData() {
		var component = this;

		var callback = function(response) {
			
			if(response.detail !== "Report generated") {
				component.setState({fi : {data: response.data, dataError : response.detail}});
			}
			else {
				for(var i = 0; i !== response.data.fidata.length; i++) {
					var perc = response.data.fidata[i].percentage.toString();
					response.data.fidata[i].percentage = perc.slice(0, (perc.indexOf(".") + 3)) + '%';
				}
				component.setState({fi : {data : response.data, dataError: false}});
			}
		};

		window._fiSponsor.getFIUserData(callback);
	}



	

	render() {
		if(!window._fiSponsor.sponsors.length) {
			window._fiSponsor.loadSessionInfo();
		}
		
		var content = (
			<p>Content not found</p>
			);
		var location = ["Dashboard", "Users"];
		if (this.state.page === "main") {

			content = (
				<UsersMain zip={this.state.zip} fi={this.state.fi} whereSubviewClick={this.whereOnClick} fiSubviewClick={this.fiOnClick} />
			);
		}
		else if(this.state.page === "whereSub") {
			location = ["Dashboard", "Users", "Zipcodes"];
			content = (
				<UsersSub />
				);
		}
		else if(this.state.page === "fiSub") {
			location = ["Dashboard", "Users", "FIs"];
			content = (
				<FIUsersSub />
				);
		}

		return (
			<MainView location={location} amount={window._fiSponsor.sponsors[0].total_saved} content={content} />
		);
  	}
}


export default Users;